module.exports = __webpack_public_path__ + "static/media/refurbishLaminateFloor2.b2001c3a.jpg";